import { Component } from 'react'
import { connect } from 'react-redux'
import Translation from '../../Translation/cont/Translation';
import getFormatedPrice from '../func/getFormatedPrice';
import getTranslationTime from '../../Translation/func/getTranslationTime';
import replaceNewline from '../../../functions/replaceNewline';
import getTranslationStringById from '../../Translation/func/getTranslationStringById';
import { EVENT_DATA_CONFIG } from '../../../constants/state';
import getData from '../../../functions/getData';

class SendEmailContainer extends Component {

  constructor(props) {
    super(props);

    this.lineBreak = '\n'
    this.doubleLineBreak = '\n\n'
    this.tripleLineBreak = '\n\n\n'
  }

  getEmailUrl() {
    const { eventData, settings } = this.props

    if (settings.form_settings.email) {
      return eventData.input_types[settings.form_settings.email]
    } else {
      return ''
    }
  }

  hidePrices() {
    return this.props.hidePrices === true
  }

  getSubject() {
    const { request_id } = this.props

    return `Angebot für die Anfrage ${request_id}`
  }

  getCoverLetter() {
    if (this.props.eventData.hasOwnProperty('cover_letter') && this.props.eventData.cover_letter) {
      return replaceNewline(this.props.eventData.cover_letter, this.lineBreak) + this.tripleLineBreak
    } else {
      return ''
    }
  }

  getExtra() {
    if (this.props.eventData.hasOwnProperty('extra') && this.props.eventData.extra) {
      if (!this.hidePrices() && this.props.eventData.hasOwnProperty('extra_price') && this.props.eventData.extra_price) {
        return replaceNewline(this.props.eventData.extra, this.lineBreak) + this.lineBreak + getFormatedPrice(this.props.eventData.extra_price) + this.doubleLineBreak
      } else {
        return replaceNewline(this.props.eventData.extra, this.lineBreak) + this.doubleLineBreak
      }
    } else {
      return ''
    }
  }
  getInputType(elementId) {
    const form_settings = this.props.settings.form_settings
    const event_data = this.props.eventData
    const headline = form_settings.element_types.items[elementId].label
    const arrayOfIds = form_settings.element_types.items[elementId].input_types

    if (0 === arrayOfIds.length) {
      return ''
    }

    let output = ""
    output += headline + this.doubleLineBreak

    for (const inputId of arrayOfIds) {
      const label = form_settings.input_types.items[inputId].form_layout_field_label
      const value = event_data.input_types[inputId]

      if (value) {
        output += label + ": " + value + this.lineBreak
      }
    }

    return output + this.doubleLineBreak
  }

  getEventType() {
    const id = this.props.eventData.event_types
    const { event_type_name } = this.props.settings.form_settings.event_types.items[id]

    if (event_type_name) {
      return `Veranstaltungs-Art: ${event_type_name}` + this.doubleLineBreak
    } else {
      return ''
    }
  }

  getProgramType() {
    const id = this.props.eventData.program_types
    const { program_type_name } = this.props.settings.form_settings.program_types.items[id]

    if (program_type_name) {
      return `Programm-Art: ${program_type_name}` + this.doubleLineBreak
    } else {
      return ''
    }
  }

  getDateTypes() {
    const { currentLang, timezone, debug, translationStrings } = this.props
    const { date } = this.props.eventData.date
    const { event_time_start, event_time_end } = this.props.eventData
    let time = ''

    if (event_time_start) {
      time += getTranslationStringById('event_mail_start', translationStrings, currentLang, 'von') + ' ' + getTranslationTime('time', timezone, currentLang, event_time_start, debug, "", "Uhr")
    }

    if (event_time_end) {
      time += ' ' + getTranslationStringById('event_mail_end', translationStrings, currentLang, 'bis') + ' ' + getTranslationTime('time', timezone, currentLang, event_time_end, debug, "", "Uhr")
    }

    if (date) {
      return `Datum: ${getTranslationTime('dateWithDay', timezone, currentLang, date, debug)}, ${time}` + this.doubleLineBreak
    } else {
      return ''
    }
  }

  getOtherFees(key, total, headline) {
    const data = this.props.eventData[key]
    const prices = this.props.eventData.prices[key]
    const settings = this.props.settings.form_settings[key].items
    const hide = this.hidePrices()
    let text = ''

    Object.keys(data).map(id => {
      const pro = '1' === settings[id].info.pro
      const name = settings[id].info.name
      const isNumber = "number" === settings[id].info.input
      const value = data[id]
      const price = prices[id]

      if (value) {
        if (isNumber) {
          if (pro) {
            text += hide
              ? `${name}: ${value}`
              : `${name}: ${value} x ${total} x ${getFormatedPrice(price)} = ${getFormatedPrice(value * total * price)}`
            text += this.lineBreak
          } else {
            text += hide
              ? `${name}: ${value}`
              : `${name}: ${value} x ${getFormatedPrice(price)} = ${getFormatedPrice(value * price)}`
            text += this.lineBreak
          }
        } else {
          if (pro) {
            text += hide
              ? `${name}: ${total}`
              : `${name}: ${total} x ${getFormatedPrice(price)} = ${getFormatedPrice(total * price)}`
            text += this.lineBreak
          } else {
            text += hide
              ? `${name}`
              : `${name}: 1 x ${getFormatedPrice(price)} = ${getFormatedPrice(price)}`
            text += this.lineBreak
          }
        }
      }
    })

    if (text) {
      text = this.lineBreak + `${headline}:` + this.lineBreak + text
    }

    return text
  }

  getItem(key, otherFeesKey, headline) {
    const data = this.props.eventData[key]
    const prices = this.props.eventData.prices[key]
    const settings = this.props.settings.form_settings[key].items
    const isNumber = "visitors" === key
    const hide = this.hidePrices()
    let text = ''
    let total = 0

    Object.keys(data).map(id => {
      const value = data[id]
      const price = prices[id]
      const name = settings[id].info.name

      if (value) {
        if (isNumber) {
          total += value
          text += hide
            ? `${name}: ${value}`
            : `${name}: ${value} x ${getFormatedPrice(price)} = ${getFormatedPrice(value * price)}`
          text += this.lineBreak
        } else {
          total += 1
          text += hide
            ? `${name}`
            : `${name}: 1 x ${getFormatedPrice(price)} = ${getFormatedPrice(price)}`
          text += this.lineBreak
        }
      }
    })

    text += this.getOtherFees(otherFeesKey, total, 'Weitere Gebühren')

    if (text) {
      text = `${headline}:` + this.lineBreak + text
      text += this.lineBreak
    }

    return text
  }

  getBody() {
    const { totalTotal, settings } = this.props
    const { form_layout, form_settings } = settings

    let bodyText = this.getCoverLetter()

    form_layout.map(({ element_types }) => {
      element_types.map(elementId => {
        const { type } = form_settings.element_types.items[elementId]

        if ('input' === type) {
          bodyText += this.getInputType(elementId)
        }

        else if ('event_types' === type) {
          bodyText += this.getEventType()
        }

        else if ('program_types' === type) {
          bodyText += this.getProgramType()
        }

        else if ('date_types' === type) {
          bodyText += this.getDateTypes()
        }

        else if ('visitors' === type) {
          bodyText += this.getItem('visitors', 'visitors_other_fees', 'Besucher:innen')
        }

        else if ('theatres' === type) {
          bodyText += this.getItem('theatres', 'theatres_other_fees', 'Säle')
        }
      })
    })

    bodyText += this.getExtra()

    if (!this.hidePrices()) {
      bodyText += `Gesamtsumme: ${getFormatedPrice(totalTotal)}`
    }

    return bodyText
  }

  getMailPath() {
    const subject = encodeURIComponent(this.getSubject())
    const body = encodeURIComponent(this.getBody())

    return `mailto:${this.getEmailUrl()}?subject=${subject}&body=${body}`
  }

  render() {
    const { transIdMail, disableMail } = this.props

    const innerSpan = (
      <span className="text text-regular">
        <Translation id={transIdMail} />
      </span>
    )

    if (disableMail) {
      return <span className="button button-submit">{innerSpan}</span>
    }

    return (
      <a href={this.getMailPath()} className="button button-submit" target="_blank">
        {innerSpan}
      </a>
    )
  }
}

const mapStateToProps = state => ({
  hidePrices: getData(state, [EVENT_DATA_CONFIG, 'hidePrices']) === true
})

export default connect(mapStateToProps)(SendEmailContainer)
